import React from "react";
import { Button, ButtonGroup } from "@mui/material";
import { IField } from "../../app/types";

/* Functional component properties */
interface Props {
  classes: any;
  items: IField[];
  handler?: (button: IField) => void;
  setClear?: (clr: string) => void;
}

/* React Functional component */
export const ButtonGroupRenderer: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  items,
  handler,
  setClear,
}): JSX.Element => {
  function handleClear() {
    if (setClear !== undefined && handler !== undefined) {
      setClear("true");
    }
  }

  return (
    <ButtonGroup
      color="primary"
      aria-label="outlined primary button group"
      // className={classes.buttonGroup}
    >
      {items.map((item: IField) => (
        <Button
          {...(item.clickable && item.clickable === "true"
            ? {}
            : { disabled: true })}
          className={classes.buttonGroupBtn}
          variant="contained"
          color="primary"
          id={item.name}
          key={item.name}
          onClick={() =>
            item.name === "CLEAR" && setClear !== undefined
              ? handleClear()
              : handler !== undefined
              ? handler(item)
              : ""
          }
        >
          {item.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
